import { createContext } from 'react'
const myLoansContext = createContext()
export default myLoansContext
